import React from 'react'
import { Text } from '@react-pdf/renderer'

interface TitleProps {
    text?: string
}

const Title: React.FC<TitleProps> = ({
    text
}) => {

    return (
        <Text
            style={{
                fontWeight: 'bold'
            }}>
            {text}
        </Text>
    )
}

export default Title
